import { SourceComponents } from '@updater/informant-core';
import { DateInput } from '@updater/ui-uds';

export const DateField: SourceComponents['DateField'] = (props) => {
  return <DateInput {...props} />;
};
